<template>
  <div v-if="product">
    <b-modal
      id="finance_configuration_category"
      title="ALTERAR CATEGORIA DO FINANCEIRO"
      no-close-on-backdrop
      hide-footer
    >
      <finance-configuration-category
        :category_id="category_id"
        :stock_item_id="product.id"
        :finance_configuration_category="finance_configuration_category"
        @success="handleSuccessFinanceConfigurationCategory"
        @get_finance_configuration_category="
          $emit('get_finance_configuration_category')
        "
      />
    </b-modal>
    <b-form @submit.prevent="evOnSubmit">
      <div class="row">
        <div class="col-md-12">
          <label-required-field label="NOME" />
          <b-input v-model="name" />
        </div>
        <div class="col-md-4">
          <label-required-field label="CATEGORIA" />
          <b-select
            :options="categories"
            text-field="name"
            value-field="id"
            v-model="stock_item_category_id"
          />
        </div>
        <div class="col-md-4">
          <label-required-field label="UNIDADE DE MEDIDA" />
          <b-select disabled :value="product.stock_item_unit_of_measurement_id">
            <b-select-option
              v-for="item in unitsOfMeasurement"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }} ({{ item.abbreviation }})
            </b-select-option>
          </b-select>
        </div>
        <div class="col-md-4">
          <label-required-field label="TAMANHO" />
          <b-input readonly :value="product.size" />
        </div>
        <div class="col-md-4">
          <label>ESTOQUE MÍNIMO</label>
          <b-input type="text" v-model="minimum_stock" />
        </div>
        <div class="col-md-4">
          <label>ESTOQUE MÁXIMO</label>
          <b-input type="text" v-model="maximum_stock" />
        </div>
        <div class="col-md-12 p-0"></div>
        <div class="col-md-4">
          <label>CUSTO DO PRODUTO</label>
          <b-input
            :disabled="readjustment != 'REAJUSTE_MANUAL'"
            type="text"
            v-model="product_cost"
            @keyup="handleValueProductCost"
          />
        </div>
        <div class="col-md-4">
          <label>LUCRO(%)</label>
          <b-input
            type="text"
            v-on:keyup="handleValueProfit"
            v-model="profit"
          />
        </div>
        <div class="col-md-4">
          <label>VALOR DA VENDA</label>
          <b-input
            :disabled="readjustment != 'REAJUSTE_MANUAL'"
            type="text"
            v-model="sale_price"
            v-on:keyup="handleValueSalePrice"
          />
        </div>
        <div class="col-md-12">
          <label>REAJUSTE</label>
          <select class="form-control" v-model="readjustment">
            <option value="REAJUSTE_MANUAL">REAJUSTE MANUAL</option>
            <option value="REAJUSTE_VALOR_MEDIO">
              REAJUSTE VALOR MÉDIO (AUTOMÁTICO)
            </option>
            <option value="REAJUSTE_MAIOR_VALOR">
              REAJUSTE MAIOR VALOR (AUTOMÁTICO)
            </option>
          </select>
        </div>
        <div class="col-md-12">
          <LatestReleasesPriceList
            type="PRODUCT"
            :id="product.id"
            :readjustment="readjustment"
            @paginate="handleLatestReleasesPriceList"
          />
        </div>
        <div class="col-md-12 pb-0" v-if="permission('read', 'financial')">
          <label>CATEGORIA DO FINANCEIRO</label>
          <b-input
            disabled
            :value="
              product.finance_configuration_category_name
                ? product.finance_configuration_category_name
                : 'NÃO INFORMADO'
            "
          />
        </div>
        <div class="col-md-12 pt-0" v-if="permission('read', 'financial')">
          <v-btn @click="handleModalFinance" class="btn-i btn-block">
            <i class="fas fa-edit mr-2 text-twenty"></i>
            ALTERAR CATEGORIA DO FINANCEIRO
          </v-btn>
        </div>
      </div>
      <errors-messages :errors="errors" />
      <b-row>
        <b-col>
          <v-btn-cancel @click="$bvModal.hide('view_product')" />
        </b-col>
        <b-col cols="auto">
          <confirmation-dialog
            message-title="EXCLUIR?"
            message-body="Deseja realmente excluir o produto?"
            open-class="btn-delete m-1"
            open-left-icon="fa-trash"
            open-text="EXCLUIR"
            @yes="handleDelete"
          />
          <v-btn-save
            :disabled="loading"
            :loading="loading"
            type="submit"
            class="ml-2"
          />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import LabelRequiredField from "../../../Components/LabelRequiredField.vue";
import VBtnCancel from "../../../Components/VBtnCancel.vue";
import VBtnSave from "../../../Components/VBtnSave.vue";
import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

import FinanceConfigurationCategory from "./finance-configuration-category.vue";

import LatestReleasesPriceList from "../latest-releases-price-list.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
} from "../../../../lib/format";

import permission from "../../../../lib/permission";

export default {
  name: "NewProduct",

  components: {
    VBtnSave,
    VBtnCancel,
    LabelRequiredField,
    ErrorsMessages,
    ConfirmationDialog,
    FinanceConfigurationCategory,
    LatestReleasesPriceList,
  },

  props: {
    product: { required: true },
    categories: Array,
    unitsOfMeasurement: Array,
    finance_configuration_category: Array,
  },

  data() {
    return {
      errors: [],
      loading: false,

      name: "",
      stock_item_category_id: "",
      category_id: "",
      minimum_stock: "",
      maximum_stock: "",
      product_cost: "",
      profit: "",
      sale_price: "",
      readjustment: "REAJUSTE_MANUAL",
    };
  },

  created() {
    this.errors = [];
    this.loading = false;

    let {
      stock_item_category_id,
      name,
      minimum_stock,
      maximum_stock,
      product_cost,
      profit,
      sale_price,
      readjustment,
    } = this.product;

    this.stock_item_category_id = stock_item_category_id;
    this.name = name;
    this.minimum_stock = minimum_stock;
    this.maximum_stock = maximum_stock;
    this.profit = profit;
    this.readjustment = readjustment;

    if (product_cost) {
      this.product_cost = formatValueOnKeyUp(String(product_cost));
    }

    if (sale_price) {
      this.sale_price = formatValueOnKeyUp(String(sale_price));
    }
  },

  watch: {
    product() {
      if (this.product) this.$bvModal.show("view_product");
    },
  },

  methods: {
    permission,

    handleLatestReleasesPriceList(stock_item_price_list) {
      const REAJUSTE_MANUAL = "REAJUSTE_MANUAL";
      const REAJUSTE_VALOR_MEDIO = "REAJUSTE_VALOR_MEDIO";
      const REAJUSTE_MAIOR_VALOR = "REAJUSTE_MAIOR_VALOR";

      let { product, readjustment } = this;

      let { product_cost, profit, sale_price } = product;

      if (profit) {
        profit = formatValueToPercentage(profit);
      }

      if (readjustment == REAJUSTE_MANUAL) {
        this.product_cost = formatValueOnKeyUp(String(product_cost));
        this.profit = profit;
        this.sale_price = formatValueOnKeyUp(String(sale_price));
      } else if (readjustment == REAJUSTE_VALOR_MEDIO) {
        let totalLastReleases = 0;
        for (let item of stock_item_price_list) {
          totalLastReleases =
            parseFloat(totalLastReleases) + parseFloat(item.value);
        }

        let productCost = product_cost;
        let salePrice = 0;

        let formatTotalLastReleases = totalLastReleases;
        if (stock_item_price_list.length == 0) {
          salePrice = this.calcSalePriceByProfit(profit, productCost);
        } else if (stock_item_price_list.length == 1) {
          productCost = formatTotalLastReleases;
          if (parseFloat(profit) > 0) {
            salePrice = this.calcSalePrice({
              total: formatTotalLastReleases,
              profit,
            });
          } else {
            salePrice = productCost;
          }
        } else if (stock_item_price_list.length == 2) {
          formatTotalLastReleases = parseFloat(formatTotalLastReleases) / 2;
          formatTotalLastReleases = formatTotalLastReleases.toFixed(2);
          productCost = formatTotalLastReleases;
          if (parseFloat(profit) > 0) {
            salePrice = this.calcSalePrice({
              total: formatTotalLastReleases,
              profit,
            });
          } else {
            salePrice = productCost;
          }
        } else if (stock_item_price_list.length == 3) {
          formatTotalLastReleases = parseFloat(formatTotalLastReleases) / 3;
          formatTotalLastReleases = formatTotalLastReleases.toFixed(2);
          productCost = formatTotalLastReleases;
          if (parseFloat(profit) > 0) {
            salePrice = this.calcSalePrice({
              total: formatTotalLastReleases,
              profit,
            });
          } else {
            salePrice = productCost;
          }
        }

        this.product_cost = formatValueOnKeyUp(String(productCost));
        this.profit = profit;
        this.sale_price = formatValueOnKeyUp(String(salePrice));
      } else if (readjustment == REAJUSTE_MAIOR_VALOR) {
        let productCost = product_cost;
        let salePrice = 0;

        if (stock_item_price_list.length > 0) {
          let { value } = stock_item_price_list[0];
          let highestValue = parseFloat(value).toFixed(2);
          productCost = highestValue;
          if (parseFloat(profit) > 0) {
            salePrice = this.calcSalePrice({ total: highestValue, profit });
          } else {
            salePrice = highestValue;
          }
        } else {
          salePrice = this.calcSalePriceByProfit(profit, product_cost);
        }

        this.product_cost = formatValueOnKeyUp(String(productCost));
        this.profit = profit;
        this.sale_price = formatValueOnKeyUp(String(salePrice));
      }
    },

    calcSalePrice({ total, profit }) {
      try {
        let sale_price = 0;
        let current = parseFloat(total);
        let percentage = parseFloat(profit) * current;
        sale_price = parseFloat(percentage) / 100;
        sale_price = sale_price.toFixed(2);
        sale_price = parseFloat(sale_price) + parseFloat(current);
        sale_price = sale_price.toFixed(2);

        return sale_price;
      } catch (error) {
        return 0;
      }
    },

    calcSalePriceByProfit(profit, product_cost) {
      let sale_price = 0;
      if (profit && parseFloat(profit) > 0) {
        let current = formatValueToOnlyNumber(product_cost);
        let percentage = profit * current;
        sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        sale_price = formatPrice(sale_price);
      } else {
        sale_price = product_cost;
      }

      return sale_price;
    },

    handleSuccessFinanceConfigurationCategory() {
      this.$bvModal.hide("view_product");
      this.$emit("updated");
    },

    handleModalFinance() {
      let { product } = this;
      this.category_id = product.finance_configuration_category_id;
      this.$bvModal.show("finance_configuration_category");
    },

    handleValueProfit: function (e) {
      let profit = formatValueToPercentage(e.target.value);
      if (profit) {
        let current = formatValueToOnlyNumber(this.product_cost);
        let percentage = profit * current;
        let sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueProductCost: function (e) {
      this.product_cost = formatValueOnKeyUp(e.target.value);

      let { profit, product_cost } = this;

      if (profit) {
        let current = formatValueToOnlyNumber(product_cost);
        let percentage = profit * current;
        let sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueSalePrice: function (e) {
      let sale_price = formatValueToOnlyNumber(e.target.value);

      this.sale_price = formatValueOnKeyUp(sale_price);

      let { product_cost } = this;

      product_cost = formatValueToOnlyNumber(product_cost);

      if (parseFloat(sale_price) > parseFloat(product_cost)) {
        let profit = parseFloat(sale_price) - parseFloat(product_cost);
        profit = parseFloat(profit) / parseFloat(product_cost);
        profit = parseFloat(profit) * 100;
        if (String(profit).indexOf(".") > -1) {
          profit = profit.toFixed(2);
        }
        this.profit = profit;
      } else {
        this.profit = 0;
      }
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let {
          product,
          name,
          stock_item_category_id,
          minimum_stock,
          maximum_stock,
          product_cost,
          profit,
          sale_price,
          readjustment,
        } = this;

        const data = {
          id: product.id,
          product_id: product.product_id,
          name,
          stock_item_category_id,
          minimum_stock,
          maximum_stock,
          product_cost,
          profit,
          sale_price,
          readjustment,
        };

        const response = await api.patch(
          "/rest-home/stock/items/product",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$bvModal.hide("view_product");
          toast(message, "success");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async handleDelete() {
      try {
        this.loading = true;

        const data = { id: this.product.id };
        const response = await api.delete("/rest-home/stock/items/product", {
          data,
        });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$bvModal.hide("view_product");
          toast(message, "success");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>